import pb from '../lib/pocketbase';

/**
 * Get the URL for a file stored in PocketBase
 * @param record The record containing the file
 * @param filename The filename from the record
 * @param collectionName The name of the collection (e.g., 'partners')
 * @param thumb Optional thumbnail size (e.g., '200x200')
 * @returns The full URL to access the file
 */
export function getFileUrl(record: any, filename: string, collectionName: string, thumb?: string): string {
  if (!filename) return '';
  
  // Manually construct PocketBase file URL
  // Format: {baseUrl}/api/files/{collectionName}/{recordId}/{filename}?thumb={thumb}
  const baseUrl = pb.baseUrl;
  let url = `${baseUrl}/api/files/${collectionName}/${record.id}/${filename}`;
  
  if (thumb) {
    url += `?thumb=${thumb}`;
  }
  
  return url;
}

/**
 * Get the logo URL for a partner
 * @param partner The partner record
 * @returns The logo URL (either from logo field or logo_url field)
 */
export function getPartnerLogoUrl(partner: any): string {
  // If partner has a logo file, use PocketBase file URL
  if (partner.logo) {
    return getFileUrl(partner, partner.logo, 'partners', '200x200');
  }
  
  // Otherwise use logo_url (for external URLs or base64)
  return partner.logo_url || '';
}
